export default __webpack_public_path__ + "media/images/features/local_delivery/episode4/LP_05-063198d62acc86c0a1f53c45daf69441.jpg";